module.exports = __webpack_public_path__ + "static/media/step-indicator-1.0cb83778.svg";